import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconBed(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-bed_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M11,45a1,1,0,0,0,2,0V44H11Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M39,45a1,1,0,0,0,2,0V44H39Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M43.05,17H39a2,2,0,0,1-2,2H29a1.85,1.85,0,0,1-.48-.07l-.12,0a1.46,1.46,0,0,1-.36-.16l-.07,0a2.13,2.13,0,0,1-.69-.71h0A2,2,0,0,1,27,17H25a2,2,0,0,1-.28,1h0a2.13,2.13,0,0,1-.69.71l-.07,0a1.46,1.46,0,0,1-.36.16l-.12,0A1.85,1.85,0,0,1,23,19H15a2,2,0,0,1-2-2H9L4.25,33h43.5Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13,13a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2h2V13a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v2h4V8.42A2.43,2.43,0,0,0,40.58,6H11.42A2.43,2.43,0,0,0,9,8.42V15h4Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M4,35v2.91A4,4,0,0,0,7.84,42H44.16A4,4,0,0,0,48,37.91V35Z"
      }));
    }
  }));
}
export default SvgIconBed;